import axios, { getData } from 'lib/nest'

export const parseResume = async (data) => {
  const response = await axios.post(`/cv/upload/external-talent`, data)
  return getData(response)
}
